import { render, staticRenderFns } from "./FormDeleterDialog.vue?vue&type=template&id=55b0dde3&scoped=true"
import script from "./FormDeleterDialog.vue?vue&type=script&lang=ts"
export * from "./FormDeleterDialog.vue?vue&type=script&lang=ts"
import style0 from "./FormDeleterDialog.vue?vue&type=style&index=0&id=55b0dde3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b0dde3",
  null
  
)

export default component.exports